import {ConnectionStatus, SignalRHub} from '@/constants/dataEnum';
import websocketObserver from '@/observers/deviceHubObserver';

// eslint-disable-next-line import/no-cycle
import subscribeEvents from './deviceEventListener';
import {startHubPromise} from './signalRManager';

export const HubMap = {
  [SignalRHub.DEVICE]: {
    subscribeEvent: subscribeEvents,
    setConnection: websocketObserver.notify.connStateHandler,
    useToken: false,
  },
};

const startSignalRHub = async (hubName, useToken) => {
  let result;
  console.info('startSignalRHub', hubName);
  try {
    result = await startHubPromise(
      hubName,
      useToken,
      // onReconnecting Hub
      (err) => {
        onReconnectingHub(hubName, err);
      },
      // onReconnected Hub
      (connectionId) => {
        onReconnectedHub(hubName, connectionId);
      },
      // onClose Hub
      (err) => {
        onHubClose(hubName, err);
      },
    );

    console.log(`${hubName} hub connection started!`);
  } catch (err) {
    result = null;
    console.error(`startSignalRHub hub: ${hubName}, Error:`, err);
    onHubConnectionStartError(hubName, err);
  }
  return result;
};

export const buildHub = async (hubName) => {
  const {subscribeEvent, setConnection, useToken} = HubMap[hubName];
  const connectionId = await startSignalRHub(hubName, useToken);

  if (connectionId) {
    if (subscribeEvent) subscribeEvent(hubName);
    if (setConnection) setConnection(ConnectionStatus.CONNECTED);
  }
};

export const initHub = () => Object.keys(HubMap).forEach((hub) => buildHub(hub));

export const onReconnectingHub = (hubName, err) => {
  console.log('reconnecting Hub', hubName, err);
  const {setConnection} = HubMap[hubName];

  if (setConnection) setConnection(ConnectionStatus.RECONNECTING);
};

export const onReconnectedHub = (hubName) => {
  console.log('reconnected Hub', hubName);

  const {setConnection} = HubMap[hubName];

  if (setConnection) setConnection(ConnectionStatus.CONNECTED);
};

export const onHubClose = (hubName, err) => {
  console.log('onHubClose Hub', hubName, err);
  const {setConnection} = HubMap[hubName];

  if (setConnection) setConnection(ConnectionStatus.CLOSE);

  // Try to reconnecting again.
  buildHub(hubName);
};

export const onHubConnectionStartError = (hubName, err) => {
  console.log('onHubConnectionStartError Hub', hubName, err);
  const {setConnection} = HubMap[hubName];

  if (setConnection) setConnection(ConnectionStatus.ERROR);

  // Try to reconnecting again.
  // buildHub(hubName);
};
